// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --fhir-api-doc-get-color: 124, 188, 207;
    --fhir-api-doc-post-color: 63, 171, 153;
    --fhir-api-doc-put-color: 231, 181, 119;
    --fhir-api-doc-delete-color: 231, 158, 158;
    --fhir-api-doc-head-color: 182, 163, 198; 
    --fhir-api-doc-patch-color: 145, 166, 188;
}

textarea[data-apidoc-data="yaml"] {
    display: none;
}

.gem-ig-api-doc {
    font-family: sans-serif;
    font-size: 12px;
}


.gem-ig-api-doc a {
    color: #000;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
    padding-bottom: 2px;
    text-decoration: none;
}

.gem-ig-api-doc a:hover {
    color: #0d7395;
}

.gem-ig-api-doc a:active {
    color: #000;
}

.gem-ig-api-doc p {
    padding: 0px;
}

.gem-ig-api-doc th {
    text-align: left;
    font-weight:bold;
    padding-right: 10px;
    padding-left: 5px;
}

.gem-ig-api-doc .operation-block {
    border: 1px solid #000;
    border-radius: 2px;
    margin: 0 0 15px;
}

.gem-ig-api-doc .operation-block-summary {
    all: inherit;
    border: 0;
    cursor:default;
    flex: 1;
    padding: 0;
    margin: 0;
    align-items: center;
    display: flex;
    box-shadow: 0 0 3px rgba(0, 0, 0, .19);
    border-bottom-left-radius: 0%;
    border-bottom-right-radius: 0%;
}

.operation-block-summary-control {
    display: flex;
}

.gem-ig-api-doc .operation-block-summary-method {
    border-radius: 2px;
    color: #fff;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 700;
    min-width: 60px;
    padding: 6px 0;
    margin: 5px;
    text-align: center;
    border-style: none;
}

.gem-ig-api-doc .operation-block-summary-path {
    align-items: center;
    color: #3b4151;
    display: flex;
    font-family: monospace;
    font-size: 14px;
    font-weight: 600;
    word-break: break-word;
}

.gem-ig-api-doc .operation-block-description {
    padding: 10px 20px 10px 20px;
}

.gem-ig-api-doc .operation-block-description.low-padding {
    padding: 0px;
    padding-bottom: 10px;
    padding-left: 20px;
}

.gem-ig-api-doc .operation-block-description.with-table {
    overflow: scroll;
}

.gem-ig-api-doc .operation-block-description.operation-example {
    padding: 0px 20px;
}

.gem-ig-api-doc .operation-block-section-header {
    background-color: #ffffff;
    padding: 10px 20px;
    font-weight: bold;
}

.gem-ig-api-doc .example {
    border-radius: 2px;
    background-color: #ffffff;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 700;
    min-width: 60px;
    padding: 0px 10px 0px 0px;
    text-align: left;
    border: 1px solid;
    border-color: #519ad9;
    height: 30px;
    cursor: pointer;
    margin-bottom: 5px;
    max-width: 400px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

}

.gem-ig-api-doc .example .label {
    border-radius: 2px 0 0 2px;
    background-color: #519ad9;
    color: #fff;
    padding: 8px;
    margin-right: 10px;
    min-width: 60px;
    font-size: 100%;
}

.gem-ig-api-doc .inline-button {
    display: inline-block;
    margin-right: 10px;
}

.gem-ig-api-doc button:hover, .gem-ig-api-doc .active-button {
    opacity: 0.5;
}

.gem-ig-api-doc .example-buttons-container{
    padding: 3px;
    text-align: right;
}

.gem-ig-api-doc table {
    max-width: 100%;
}

.gem-ig-api-doc table.params-table tr th:nth-child(1) {
    width: 240px;
}

.gem-ig-api-doc table.params-table tr th:nth-child(2) {
    width: 120px;
}

.gem-ig-api-doc table.params-table tr th:nth-child(3) {
    width: 680px;
}

.gem-ig-api-doc table tr td {
    border-bottom: 1px solid rgba(192, 192, 192, 0.2);
    border-spacing: 0;
}

.gem-ig-api-doc table tr:last-child td {
    border-bottom: none;
}

.gem-ig-api-doc table tr:nth-child(even) {
    background: #eeeeee89;
}

.gem-ig-api-doc table tr:nth-child(odd) {
    background: #ffffff89;
}

.gem-ig-api-doc table th {
    background: rgba(var(--fhir-api-doc-color), 0.2);
}

.operation-block-description > pre {
    background-color: #171c19;
    color: #fff;
    padding: 10px;
}

.gem-ig-api-doc .operation-example > pre {
    background-color: #171c19;
    color: #fff;
    overflow: auto;
    white-space: pre;
    padding: 10px;
}

.gem-ig-api-doc code {
    color: inherit;
}

.gem-ig-api-doc .operation-example > pre > .html-example {
    overflow: auto;
    padding: 10px;
    color: black;
    background: white;

}

/* Common styles for operation-block by method */
.gem-ig-api-doc .operation-block[class*="operation-block-"] {
    border-color: rgba(var(--fhir-api-doc-color), 1.0);
    background-color: rgba(var(--fhir-api-doc-color), 0.1);
}

.gem-ig-api-doc .operation-block-summary-method[class*="operation-block-"] {
    background-color: rgba(var(--fhir-api-doc-color), 1.0);
}

.gem-ig-api-doc .operation-block[class*="operation-block-"] .example {
    border-color: rgba(var(--fhir-api-doc-color), 1.0);
}

.gem-ig-api-doc .operation-block[class*="operation-block-"] .example .label {
    background-color: rgba(var(--fhir-api-doc-color), 1.0);
}


/* Specific method colors */
.gem-ig-api-doc .operation-block-get {
    --fhir-api-doc-color: var(--fhir-api-doc-get-color);
}

.gem-ig-api-doc .operation-block-post {
    --fhir-api-doc-color: var(--fhir-api-doc-post-color);
}

.gem-ig-api-doc .operation-block-put {
    --fhir-api-doc-color: var(--fhir-api-doc-put-color);
}

.gem-ig-api-doc .operation-block-delete {
    --fhir-api-doc-color: var(--fhir-api-doc-delete-color);
}

.gem-ig-api-doc .operation-block-head {
    --fhir-api-doc-color: var(--fhir-api-doc-head-color);
}

.gem-ig-api-doc .operation-block-patch {
    --fhir-api-doc-color: var(--fhir-api-doc-patch-color);
}

.gem-ig-copy-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 5px;
}

/* Sprachangabe links */
.gem-id-code-lang {
    text-align: left;
    font-size: 13px;
    font-family: 'Courier New', Courier, monospace;
    background-color: rgba(255, 255, 255, 0.187);
    /* background-color: rgb(110, 110, 110); */
    color: #fff;
}

.operation-block .gem-id-code-lang {
    margin-left: -10px;
    margin-top: -20px;
    border-bottom-right-radius: 30%;
    padding: 6px;
}

/* Kopierbutton rechts */
.gem-ig-copy-button-wrapper {
    text-align: right;
}

.gem-ig-copy-button-wrapper button {
    cursor: pointer;
    border: #fff solid 1px;
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    padding: 5px;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./css/ig.apidoc.gematik.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,0CAA0C;IAC1C,wCAAwC;IACxC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,4CAA4C;IAC5C,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,cAAc;IACd,OAAO;IACP,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,sCAAsC;IACtC,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;;AAE3B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iDAAiD;IACjD,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,iBAAiB;;AAErB;;AAEA,gDAAgD;AAChD;IACI,kDAAkD;IAClD,sDAAsD;AAC1D;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,sDAAsD;AAC1D;;;AAGA,2BAA2B;AAC3B;IACI,mDAAmD;AACvD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,4CAA4C;IAC5C,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA,wBAAwB;AACxB;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,eAAe;AACnB","sourcesContent":[":root {\n    --fhir-api-doc-get-color: 124, 188, 207;\n    --fhir-api-doc-post-color: 63, 171, 153;\n    --fhir-api-doc-put-color: 231, 181, 119;\n    --fhir-api-doc-delete-color: 231, 158, 158;\n    --fhir-api-doc-head-color: 182, 163, 198; \n    --fhir-api-doc-patch-color: 145, 166, 188;\n}\n\ntextarea[data-apidoc-data=\"yaml\"] {\n    display: none;\n}\n\n.gem-ig-api-doc {\n    font-family: sans-serif;\n    font-size: 12px;\n}\n\n\n.gem-ig-api-doc a {\n    color: #000;\n    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n    padding-bottom: 2px;\n    text-decoration: none;\n}\n\n.gem-ig-api-doc a:hover {\n    color: #0d7395;\n}\n\n.gem-ig-api-doc a:active {\n    color: #000;\n}\n\n.gem-ig-api-doc p {\n    padding: 0px;\n}\n\n.gem-ig-api-doc th {\n    text-align: left;\n    font-weight:bold;\n    padding-right: 10px;\n    padding-left: 5px;\n}\n\n.gem-ig-api-doc .operation-block {\n    border: 1px solid #000;\n    border-radius: 2px;\n    margin: 0 0 15px;\n}\n\n.gem-ig-api-doc .operation-block-summary {\n    all: inherit;\n    border: 0;\n    cursor:default;\n    flex: 1;\n    padding: 0;\n    margin: 0;\n    align-items: center;\n    display: flex;\n    box-shadow: 0 0 3px rgba(0, 0, 0, .19);\n    border-bottom-left-radius: 0%;\n    border-bottom-right-radius: 0%;\n}\n\n.operation-block-summary-control {\n    display: flex;\n}\n\n.gem-ig-api-doc .operation-block-summary-method {\n    border-radius: 2px;\n    color: #fff;\n    font-family: sans-serif;\n    font-size: 12px;\n    font-weight: 700;\n    min-width: 60px;\n    padding: 6px 0;\n    margin: 5px;\n    text-align: center;\n    border-style: none;\n}\n\n.gem-ig-api-doc .operation-block-summary-path {\n    align-items: center;\n    color: #3b4151;\n    display: flex;\n    font-family: monospace;\n    font-size: 14px;\n    font-weight: 600;\n    word-break: break-word;\n}\n\n.gem-ig-api-doc .operation-block-description {\n    padding: 10px 20px 10px 20px;\n}\n\n.gem-ig-api-doc .operation-block-description.low-padding {\n    padding: 0px;\n    padding-bottom: 10px;\n    padding-left: 20px;\n}\n\n.gem-ig-api-doc .operation-block-description.with-table {\n    overflow: scroll;\n}\n\n.gem-ig-api-doc .operation-block-description.operation-example {\n    padding: 0px 20px;\n}\n\n.gem-ig-api-doc .operation-block-section-header {\n    background-color: #ffffff;\n    padding: 10px 20px;\n    font-weight: bold;\n}\n\n.gem-ig-api-doc .example {\n    border-radius: 2px;\n    background-color: #ffffff;\n    font-family: sans-serif;\n    font-size: 12px;\n    font-weight: 700;\n    min-width: 60px;\n    padding: 0px 10px 0px 0px;\n    text-align: left;\n    border: 1px solid;\n    border-color: #519ad9;\n    height: 30px;\n    cursor: pointer;\n    margin-bottom: 5px;\n    max-width: 400px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n}\n\n.gem-ig-api-doc .example .label {\n    border-radius: 2px 0 0 2px;\n    background-color: #519ad9;\n    color: #fff;\n    padding: 8px;\n    margin-right: 10px;\n    min-width: 60px;\n    font-size: 100%;\n}\n\n.gem-ig-api-doc .inline-button {\n    display: inline-block;\n    margin-right: 10px;\n}\n\n.gem-ig-api-doc button:hover, .gem-ig-api-doc .active-button {\n    opacity: 0.5;\n}\n\n.gem-ig-api-doc .example-buttons-container{\n    padding: 3px;\n    text-align: right;\n}\n\n.gem-ig-api-doc table {\n    max-width: 100%;\n}\n\n.gem-ig-api-doc table.params-table tr th:nth-child(1) {\n    width: 240px;\n}\n\n.gem-ig-api-doc table.params-table tr th:nth-child(2) {\n    width: 120px;\n}\n\n.gem-ig-api-doc table.params-table tr th:nth-child(3) {\n    width: 680px;\n}\n\n.gem-ig-api-doc table tr td {\n    border-bottom: 1px solid rgba(192, 192, 192, 0.2);\n    border-spacing: 0;\n}\n\n.gem-ig-api-doc table tr:last-child td {\n    border-bottom: none;\n}\n\n.gem-ig-api-doc table tr:nth-child(even) {\n    background: #eeeeee89;\n}\n\n.gem-ig-api-doc table tr:nth-child(odd) {\n    background: #ffffff89;\n}\n\n.gem-ig-api-doc table th {\n    background: rgba(var(--fhir-api-doc-color), 0.2);\n}\n\n.operation-block-description > pre {\n    background-color: #171c19;\n    color: #fff;\n    padding: 10px;\n}\n\n.gem-ig-api-doc .operation-example > pre {\n    background-color: #171c19;\n    color: #fff;\n    overflow: auto;\n    white-space: pre;\n    padding: 10px;\n}\n\n.gem-ig-api-doc code {\n    color: inherit;\n}\n\n.gem-ig-api-doc .operation-example > pre > .html-example {\n    overflow: auto;\n    padding: 10px;\n    color: black;\n    background: white;\n\n}\n\n/* Common styles for operation-block by method */\n.gem-ig-api-doc .operation-block[class*=\"operation-block-\"] {\n    border-color: rgba(var(--fhir-api-doc-color), 1.0);\n    background-color: rgba(var(--fhir-api-doc-color), 0.1);\n}\n\n.gem-ig-api-doc .operation-block-summary-method[class*=\"operation-block-\"] {\n    background-color: rgba(var(--fhir-api-doc-color), 1.0);\n}\n\n.gem-ig-api-doc .operation-block[class*=\"operation-block-\"] .example {\n    border-color: rgba(var(--fhir-api-doc-color), 1.0);\n}\n\n.gem-ig-api-doc .operation-block[class*=\"operation-block-\"] .example .label {\n    background-color: rgba(var(--fhir-api-doc-color), 1.0);\n}\n\n\n/* Specific method colors */\n.gem-ig-api-doc .operation-block-get {\n    --fhir-api-doc-color: var(--fhir-api-doc-get-color);\n}\n\n.gem-ig-api-doc .operation-block-post {\n    --fhir-api-doc-color: var(--fhir-api-doc-post-color);\n}\n\n.gem-ig-api-doc .operation-block-put {\n    --fhir-api-doc-color: var(--fhir-api-doc-put-color);\n}\n\n.gem-ig-api-doc .operation-block-delete {\n    --fhir-api-doc-color: var(--fhir-api-doc-delete-color);\n}\n\n.gem-ig-api-doc .operation-block-head {\n    --fhir-api-doc-color: var(--fhir-api-doc-head-color);\n}\n\n.gem-ig-api-doc .operation-block-patch {\n    --fhir-api-doc-color: var(--fhir-api-doc-patch-color);\n}\n\n.gem-ig-copy-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 5px;\n}\n\n/* Sprachangabe links */\n.gem-id-code-lang {\n    text-align: left;\n    font-size: 13px;\n    font-family: 'Courier New', Courier, monospace;\n    background-color: rgba(255, 255, 255, 0.187);\n    /* background-color: rgb(110, 110, 110); */\n    color: #fff;\n}\n\n.operation-block .gem-id-code-lang {\n    margin-left: -10px;\n    margin-top: -20px;\n    border-bottom-right-radius: 30%;\n    padding: 6px;\n}\n\n/* Kopierbutton rechts */\n.gem-ig-copy-button-wrapper {\n    text-align: right;\n}\n\n.gem-ig-copy-button-wrapper button {\n    cursor: pointer;\n    border: #fff solid 1px;\n    background-color: rgba(0, 0, 0, 0.3);\n    color: #fff;\n    padding: 5px;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
